

























































































































































import dayJs from 'dayjs';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { ZboziDruh } from '@/modules/ciselnik/skladove/zbozidruh';
import { listFactory } from '@/main/pages';
import _, { toNumber } from 'lodash';

import {
	cellNames,
	CellNamesObject,
	// eslint-disable-next-line no-unused-vars
	Row,
	intToRgb,
	Column,
} from '@/main/utils/table';

import { NAME } from './constants';
import { listMutations } from './store/types';
import { store } from './store/list';


export default listFactory(NAME, store).extend({
	components: {
		ZboziDruhSelect: ZboziDruh.components.Select,
		DodavatelSelect: Dodavatel.components.Select,
	},
	data() {
		return {
			SBesPohybu: true,
			SBesPohybuSelectList: [
				{
					Text: this.LocalizePopisostatni('bezPohyb'),
					Value: true,
				},
				{
					Text: this.LocalizePopisostatni('sPohyb'),
					Value: false,
				},
			],
		};
	},
	computed: {
		partsTable() : any {
			let idColumn: number;
			_.forEach(this.table.columns, (col: Column) => {
				if (col?.columnId !== null) { idColumn = toNumber(col?.columnId); } else {
					col.columnId = (idColumn + 1).toString();
					idColumn = toNumber(col.columnId);
				}
			});

			return this.table;
		},
		mutationsMappers() {
			return {
				zboziDruh: `${this.storeUri}/${listMutations.ZBOZI_DRUH_LIST_MAPPER}`,
				dodavatel: `${this.storeUri}/${listMutations.DODAVATEL_LIST_MAPPER}`,
			};
		},
		zboziDruhFilter() {
			return { VyrobekndOzn: this.VyrobekndOzn };
		},
		cellNamesCmp(): CellNamesObject {
			return cellNames(this.table);
		},
	},
	methods: {
		Mesicu(count: number) {
			return `${count} ${this.LocalizeLocal('Months')}`;
		},
		setObratkovostDatOd(mesicu: number) {
			this.ObratkovostDatOd = dayJs(this.ObratkovostDatDo!)
				.add(mesicu, 'M')
				.format();
		},

		changeObratkovostVydejPrp(event: any) {
			this.ObratkovostVydejPrp = event;
			this.ObratkovostPrijemPrp = !this.ObratkovostPrijemPrp && !this.ObratkovostVydejPrp;
		},
		changeObratkovostPrijemPrp(event: any) {
			this.ObratkovostPrijemPrp = event;
			this.ObratkovostVydejPrp = !this.ObratkovostPrijemPrp && !this.ObratkovostVydejPrp;
		},

		tableCellStyle({ row, column }:{ row:Row, column: any }) {
			if (column.label === this.LocalizePopisPoli('NDSKLAD_CELL_COLOUR')) {
				const rgb = intToRgb(row.cells[this.cellNamesCmp.CELL_COLOUR]);
				return { background: rgb, color: 'transparent' };
			}
			if (column.label === this.LocalizePopisostatni('PARTS_LIMITS')) {
				return {
					background: row.cells[this.cellNamesCmp.PARTS_LIMITS],
					color: 'transparent',
					border: '6px solid white',
					borderRadius: '30px',
				};
			}
			if (_.has(this.cellNamesCmp, 'ROWCOLOR')) {
				const rgb = row.cells[this.cellNamesCmp.ROWCOLOR];
				if (rgb) return { background: rgb };
			}
			return null;
		},
	},
});
